import styled from "styled-components"
import { ReservationInfoWrapper } from "../reservationInfo/styles"

export const PriceDataWrapper = styled(ReservationInfoWrapper)``
